export const LESSONS = '/lessons'
export const STUDENT_LESSONS_LIST = '/:ccls_module_id/student-lessons'
